module.exports = __webpack_public_path__ + "img/partner8.0586bbde.png";